(ns frontend.ui.page.fund.investor-references.event
  (:require
   [frontend.state.current-session :as session]
   [frontend.ui.page.fund.investor-references.model :as model]
   [frontend.updates.entity-scope :as entity-scope]
   [frontend.utils :as fu]
   [re-frame.core :as rf]))

(rf/reg-cofx ::generation
             (fn [coeffects] (assoc coeffects ::generation (random-uuid))))

(defn open
  [{:keys [db] generation ::generation} [_ {:keys [owner-id] :as request}]]
  (let [config (model/configuration request)
        previous (model/state db owner-id)
        scopes (model/scopes (assoc config :owner-id owner-id :generation generation))]
    (if (= config (:config previous))
      {:db db}
      {:db (assoc-in db (conj model/root-path owner-id)
                     {:config config
                      :generation generation
                      :scopes scopes
                      :batches (into {} (map (fn [{:keys [batch-id]}]
                                               [batch-id {:loading? true}])) scopes)})
       :fx [[::close-scopes (:scopes previous)]
            [::open-scopes scopes]]})))

(rf/reg-event-fx ::open [(rf/inject-cofx ::generation)] open)

(defn close
  [{:keys [db]} [_ owner-id]]
  {:db (update-in db model/root-path dissoc owner-id)
   ::close-scopes (:scopes (model/state db owner-id))})

(rf/reg-event-fx ::close close)

(defn received
  [{:keys [db]} [_ {:keys [owner-id batch-id entity-id] :as scope} message]]
  (if (and (model/active? db scope)
           (let [previous-basis (get-in (model/state db owner-id) [:batches batch-id :basis-t])]
             (or (nil? previous-basis)
                 (and (int? (:basis-t message))
                      (> (:basis-t message) previous-basis)))))
    (let [upserts (->> (:ops message)
                       (filter (fn [op] (= :upsert (:op op))))
                       (mapcat :entities)
                       vec)
          root-present? (some (fn [entity] (= entity-id (:db/id entity))) upserts)]
      (cond-> {:db (assoc-in db (into model/root-path [owner-id :batches batch-id])
                             {:loading? false
                              :basis-t (:basis-t message)
                              :error (when-not root-present? :unavailable)})}
        root-present? (assoc ::merge-entities
                             (filterv (fn [entity] (= :entity.type/investor (:entity/type entity)))
                                      upserts))))
    {:db db}))

(rf/reg-event-fx ::received received)

(defn failed
  [db [_ {:keys [owner-id batch-id] :as scope} error]]
  (if (model/active? db scope)
    (update-in db (into model/root-path [owner-id :batches batch-id])
               assoc
               :loading? false
               :error (or error :request-failed))
    db))

(rf/reg-event-db ::failed failed)

(rf/reg-fx
 ::open-scopes
 (fn [scopes]
   (doseq [scope scopes]
     (entity-scope/open!
      (assoc scope
             :on-open (fn [response]
                        (let [body (or (:body response) response)]
                          (rf/dispatch [::received scope (:initial-message body)])))
             :on-message (fn [message] (rf/dispatch [::received scope message]))
             :on-error (fn [error] (rf/dispatch [::failed scope error])))))))

(rf/reg-fx
 ::close-scopes
 (fn [scopes]
   (doseq [{:keys [entity-id instance-id]} scopes]
     (entity-scope/close! entity-id instance-id))))

(rf/reg-fx
 ::merge-entities
 (fn [entities]
   ;; Scope disposal must not delete records owned by another view or legacy sync.
   (fu/manage-entities session/reverse-lookup session/session entities)))
